<template>
  <v-container>
    <v-row class="">
      <v-col
        cols="12">
        <h1>Frequently Asked Questions</h1>
        <p>Nunc laoreet in mauris quis convallis. Donec dapibus faucibus consectetur. Ut felis nisi, gravida in ipsum in, maximus sollicitudin quam. Suspendisse maximus augue sapien, eget bibendum velit sagittis at.</p>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <h2>Table of Contents</h2>
        <ul>
          <li><a @click="$vuetify.goTo('#q1')" class="font-weight-medium"># What is the average air speed velocity of a laden swallow?</a></li>
          <li><a @click="$vuetify.goTo('#q2')" class="font-weight-medium"># FAQ Item 2</a></li>
          <li><a @click="$vuetify.goTo('#q2')" class="font-weight-medium"># FAQ Item 3</a></li>
          <li><a @click="$vuetify.goTo('#q2')" class="font-weight-medium"># FAQ Item 4</a></li>
          <li><a @click="$vuetify.goTo('#q2')" class="font-weight-medium"># FAQ Item 5</a></li>
        </ul>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <h2>Questions</h2>
        <p style="padding-bottom: 20px;">Have a question that belongs here? Tell us in our Discord Community or create a request on our Issue Generator.</p>
        <div style="margin-top: 400px;">spacer to test anchor links</div>
        <ul>
          <li>
            <p><strong id="q1">What is the average air speed velocity of a laden swallow?</strong></p>
            <p>In the end, it’s concluded that the airspeed velocity of a (European) unladen swallow is about 24 miles per hour or 11 meters per second.</p>
            <p>But, the real question is not about swallows at all. King Arthur in the movie had two coconut shells that he banged together to simulate the sound of a horse galloping. No one seems to know where he got them. So, the real question is how did the coconut get to medieval England? Is it possible that a swallow carried it over?</p>
          </li>
        </ul>
        <ul>
          <li>
            <p><strong id="q2">This is question two?</strong></p>
            <p>This is an example of an answer to an question. Aliquam auctor egestas quam quis fringilla. Praesent ut metus eu eros mollis dignissim. Vivamus scelerisque urna et lacinia sollicitudin. Cras fringilla euismod neque ut ultrices. Integer iaculis enim lorem, id feugiat ante consectetur at.</p>
          </li>
        </ul>
        <ul>
          <li>
            <p><strong id="q3">This is question 3?</strong></p>
            <p>This is an example of an answer to an question. Aliquam auctor egestas quam quis fringilla. Praesent ut metus eu eros mollis dignissim. Vivamus scelerisque urna et lacinia sollicitudin. Cras fringilla euismod neque ut ultrices. Integer iaculis enim lorem, id feugiat ante consectetur at.</p>
          </li>
        </ul>
        <ul>
          <li>
            <p><strong id="q4">This is question FOUR?</strong></p>
            <p>This is an example of an answer to an question. Aliquam auctor egestas quam quis fringilla. Praesent ut metus eu eros mollis dignissim. Vivamus scelerisque urna et lacinia sollicitudin. Cras fringilla euismod neque ut ultrices. Integer iaculis enim lorem, id feugiat ante consectetur at.</p>
          </li>
        </ul>
        <ul>
          <li>
            <p><strong id="q5">This is question Cinco?</strong></p>
            <p>This is an example of an answer to an question. Aliquam auctor egestas quam quis fringilla. Praesent ut metus eu eros mollis dignissim. Vivamus scelerisque urna et lacinia sollicitudin. Cras fringilla euismod neque ut ultrices. Integer iaculis enim lorem, id feugiat ante consectetur at.</p>
          </li>
        </ul>

      </v-col>
    </v-row>

  </v-container>
</template>
<script>

  export default {
    name: 'Faq',
  }
</script>
